/** 来源：foodbuy/market Alert；默认 danger，danger 使用 alert，其余使用 status。 */
import type { HTMLAttributes, ReactNode } from 'react'
import { alertToneClasses, type Tone } from './tones'

export type AlertProps = HTMLAttributes<HTMLDivElement> & {
  tone?: Tone
  title?: ReactNode
  action?: ReactNode
  children: ReactNode
}

export function Alert({ tone = 'danger', title, action, className = '', children, role, ...props }: AlertProps) {
  return (
    <div
      className={`flex items-start gap-3 rounded-[var(--radius-md)] border-l-4 px-3.5 py-2.5 text-sm ${alertToneClasses[tone]} ${className}`.trim()}
      role={role ?? (tone === 'danger' ? 'alert' : 'status')}
      {...props}
    >
      <div className="min-w-0 flex-1">
        {title ? <p className="m-0 font-medium text-[var(--color-ink)]">{title}</p> : null}
        <div className={title ? 'mt-0.5' : ''}>{children}</div>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  )
}
